import { AIChatModeSettings } from "./AIChatModeSettings";

interface BuilderFlowProps {
  // Minimal props needed for AI-only mode
}

export const BuilderFlow = ({}: BuilderFlowProps) => {

  return (
    <div className="space-y-6">
      {/* AI-Only Chat Content */}
      <AIChatModeSettings />
    </div>
  );
};
